<template>
  <!-- 学历统计 -->
  <div class="box fl">
    <div class="line">
      <el-divider></el-divider>
    </div>
    <div class="tu">
      <div
        style="width:100%;height:100%"
        class="chart-class"
        ref="length"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
   props: {
    teachingAgeList: "",
  },
  computed: {
    nameList() {
      return this.teachingAgeList.map((item) => item.name);
    },
  },
  data() {
    return {};
  },
  created() {
    this.teachingAgeList.forEach((item) => {
      item.value = item.nums;
      item.name = item.name.replace("年","")+"年";//防止出现多个年
    });
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      let option = {
        color: [
          "#36CB8C",
          "#FFD900",
          "#FF7250",
          "#597EF7",
          "#DB3BF4",
          "#8543E0",
        ],
        grid: {
          left: "2%",
          top: "1%",
          bottom: 10,
          right: "1%",
          containLabel: true,
        },
        tooltip: {
          trigger: "item",
          textStyle: {
            fontSize: 14,
          },
          formatter: "{b} : {c} ({d}%)",
        },
        //图片设置
        graphic: {
          elements: [
            {
              type: "image",
              z: 3,
              style: {
                width: 100,
                height: 100,
              },
              left: "center",
              top: "center",
              position: [100, 100],
            },
          ],
        },
        //中间固定的得分
        title: [
          {
            text: "教龄占比统计",
            x: "50%",
            y: "0%",
            textAlign: "center",
            textStyle: {
              fontSize: "24",
              fontWeight: "700",
              color: "#555",
              textAlign: "center",
            },
          },
        ],
        legend: {
          x: "left",
          top: "15%",
          textStyle: {
            color: "rgba(0, 0, 0, 0.45)",
            fontSize: 13,
            // left:500,
          },
          //原点
          icon: "circle",
          //修改icon图形大小
          itemHeight: 6,
          data: this.nameList,
        },
        calculable: true,
        series: [
          //最外面的圆环
          {
            type: "pie",
            radius: ["59.5%", "60%"],
            center: ["55%", "70%"],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            name: "",
            data: [
              {
                name: "",
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#36cb8c",
                  },
                },
              },
            ],
          },
          //里面的内容圆环
          {
            stack: "a",
            type: "pie",
            radius: ["10%", "55%"],
            center: ["55%", "70%"],
            roseType: "area",
            zlevel: 10,
            //百分比 名称 显示
            label: {
              show: false,
              // normal: {
              //   formatter: "{d}%",
              //   borderWidth: 0,
              //   borderRadius: 4,
              //   padding: [0, -50],
              //   height: 40,
              //   fontSize: 12,
              //   align: "center",
              //   rich: {
              //     b: {
              //       fontSize: 13,
              //       lineHeight: 5,
              //       color: "#41B3DC",
              //     },
              //   },
              // },
            },
            //指引的线
            labelLine: {
              show: false,
            },
            data: this.teachingAgeList,
          },
        ],
      };

      let myChart = this.$echarts.init(this.$refs.length);
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  .line {
    position: relative;
    top: 0px;
    left: 0px;
    .el-divider--horizontal {
      position: absolute;
      top: 65px;
      left: 0px;
    }
  }
  box-sizing: border-box;
  width: 278px;
  height: 282px;
  margin-bottom: 24px;
  margin-right: 24px;
  background: #fff;
  border-radius: 7px;
  padding: 20px 24px;
  .tu {
    width: 100%;
    height: 100%;
  }
}
</style>
